export function menu(wrapper = "main-menu") {
    const mainNavigationWrapper = document.querySelector("." + wrapper);
    if (mainNavigationWrapper) {
        const hamburger = mainNavigationWrapper.querySelector(".hamburger");
        hamburger.addEventListener("click", () => {
            if (hamburger.classList.contains("is-open")) {
                hamburger.classList.remove("is-open");
                mainNavigationWrapper
                    .querySelector(".navigation-wrapper")
                    .classList.remove("translate-x-0");
                mainNavigationWrapper
                    .querySelector(".navigation-wrapper")
                    .classList.add("translate-x-full");
            } else {
                hamburger.classList.add("is-open");
                mainNavigationWrapper
                    .querySelector(".navigation-wrapper")
                    .classList.add("translate-x-0");
                mainNavigationWrapper
                    .querySelector(".navigation-wrapper")
                    .classList.remove("translate-x-full");
            }
        });

        let parentNavigationItemsForMobile =
            mainNavigationWrapper.querySelectorAll(
                ".js-toggle-mobile-inner-nav"
            );
        parentNavigationItemsForMobile.forEach(function (item) {
            let navDiv = item.querySelector("div");
            item.addEventListener("click", () => {
                if (
                    item.parentElement.nextElementSibling.classList.contains(
                        "is-open"
                    )
                ) {
                    item.parentElement.nextElementSibling.classList.remove(
                        "is-open"
                    );
                    item.parentElement.nextElementSibling.removeAttribute(
                        "style"
                    );
                    if (navDiv) {
                        navDiv.classList.remove("opacity-0");
                    }
                } else {
                    item.parentElement.nextElementSibling.classList.add(
                        "is-open"
                    );
                    item.parentElement.nextElementSibling.style.height =
                        item.parentElement.nextElementSibling.scrollHeight +
                        "px";
                    if (navDiv) {
                        navDiv.classList.add("opacity-0");
                    }
                }
            });
        });
    }
}
